export const SET_TICKET_TYPES = 'SET_TICKET_TYPES'
export const ADD_TICKET_TYPE = 'ADD_TICKET_TYPE'
export const UPDATE_TICKET_TYPE = 'UPDATE_TICKET_TYPE'
export const DELETE_TICKET_TYPE = 'DELETE_TICKET_TYPE'
export const LOAD_TEMPLATE_KEY = 'LOAD_TEMPLATE_KEY'
//export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE'
export const SET_CURRENT_TICKET_TEMPLATE = 'SET_CURRENT_TICKET_TEMPLATE'